import { createRoute, type AnyRoute } from "@tanstack/react-router";
import { Landmark } from "lucide-react";

import type { FeatureModule } from "@/features/types";
import { guarded } from "@/lib/auth";

import { CashFlowPage } from "./pages/CashFlowPage";

export type CashFlowTab =
  | "summary"
  | "waterfall"
  | "weekly"
  | "accuracy"
  | "uploads"
  | "mapping"
  | "assumptions"
  | "how-to"
  | "admin";

export interface CashFlowSearch {
  tab?: CashFlowTab;
  run?: string;
}

const TABS: readonly CashFlowTab[] = [
  "waterfall",
  "weekly",
  "accuracy",
  "uploads",
  "mapping",
  "assumptions",
  "how-to",
  "admin",
];

function validateCashFlowSearch(search: Record<string, unknown>): CashFlowSearch {
  const out: CashFlowSearch = {};
  if (TABS.includes(search.tab as CashFlowTab)) out.tab = search.tab as CashFlowTab;
  if (typeof search.run === "string" && search.run) out.run = search.run;
  return out;
}

export const cashFlowModule: FeatureModule = {
  key: "cash_flow",
  nav: {
    label: "Cash Flow",
    icon: Landmark,
    to: "/cash-flow",
    requires: "cash_flow.read",
    order: 30,
    group: "Finance",
  },
  routes: (rootRoute) => [
    createRoute({
      getParentRoute: () => rootRoute,
      path: "/cash-flow",
      component: guarded("cash_flow.read", CashFlowPage),
      validateSearch: validateCashFlowSearch,
    }),
  ] as unknown as AnyRoute[],
};
